module.exports = __webpack_public_path__ + "img/descending.e958c0d8.svg";